// extracted by mini-css-extract-plugin
module.exports = {"block":"_11sD_p mz-cancel-buttons","cancelled":"QwHXAI","cancel":"_32TRN- mz-cancel-buttons__cancel","change":"_3B_oRr mz-cancel-buttons__change"};